import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import React, { useState } from 'react';
import { ImageAsset, SVGAsset } from 'res';
import FullPageModal, { FullPageModalContent } from '../..';


import "./styles.css";
import "./mobile.css";

/**
 * @function CheckImagePreviewModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the CheckImagePreviewModal
 */
export default function CheckImagePreviewModal(props) {
  // Data passed.
  const data = props.data ?? {};

  // Click events.
  const [ checkView, setCheckView ] = useState(data.view);
  const onChevronClick = prop => val => {
    setCheckView(prop === "leftChevron" ? "front" : "back");
  };
  const onCheckImageTileClick = prop => val => setCheckView(prop === "frontCheckImage" ? "front" : "back");

  return (
    <FullPageModal id="CheckImagePreviewModal" className="check-image-preview-modal" headerText="Image Viewer" >
      <FullPageModalContent>
        <div className="flex-container flex-vertical check-image-preview-modal-container">
          {/* Check front image preview */}
          { checkView === "front" &&
            <div className="flex-container flex-horizontal align-center image-container check-front-image-container flex-height">
              <div className="flex-width flex-container flex-horizontal justify-center" >
                <ImageAsset id="CheckFrontFilledOut" />
              </div>
              <div className="set-width text-center clickable">
                <ChevronButtonView icon="RightChevronIcon" onClick={ onChevronClick("rightChevron") } />
              </div>
              
            </div>
          }
          {/* Check back image preview */}
          { checkView === "back" &&
            <div className="flex-container flex-horizontal flex-height align-center image-container check-back-image-container">
              <div className="set-width text-center clickable">
                <ChevronButtonView icon="LeftChevronIcon" onClick={ onChevronClick("leftChevron") } />
              </div>
              <div className="flex-width flex-container flex-horizontal justify-center">
                <ImageAsset id="CheckBackEndorsed" />
              </div>
              
            </div>
          }
          {/* Magnifying glass container */}
          <div className="flex-container flex-horizontal magnifying-glass-container">
            <div className="flex-width text-right ">
              <DisabledPrompt>
                <SVGAsset id="PlusMagnifyingGlassIcon" className="plus-magnifying-glass-icon clickable" />
              </DisabledPrompt>
            </div>
            <div className="flex-width">
              <DisabledPrompt>
                <SVGAsset id="MinusMagnifyingGlassIcon" className="minus-magnifying-glass-icon clickable" />
              </DisabledPrompt>
            </div>
          </div>
          {/* Check image tile view container */}
          <div className="flex-container flex-horizontal all-center check-image-tile-view-container">
            <div className="flex-width text-right check-front">
              <CheckImageTileView image="CheckFrontFilledOut" onClick={ onCheckImageTileClick("frontCheckImage") } />
            </div>
            <div className="flex-width check-back">
              <CheckImageTileView image="CheckBackEndorsed" onClick={ onCheckImageTileClick("backCheckImage") } />
            </div>
          </div>
        </div>
      </FullPageModalContent>
    </FullPageModal>
  );
}

/**
 * @function ChevronButtonView
 * @return {React.Component}
 * @exported false
 * @description The main component for the ChevronButtonView. This component allows to switch to front or back of the check image on click.
 * @param {STRING} icon - Sets the icon for the button.
 * @param {STRING} onClick - Set an event handler when the button is clicked.
 */
function ChevronButtonView(props) {
  const icon = props.icon ?? "";
  const onClick = props.onClick ?? null;

  return (
    <SVGAsset id={icon} onClick={onClick} className="clickable" />
  )
}

/**
 * @function CheckImageTileView
 * @return {React.Component}
 * @exported false
 * @description The main component for the CheckImageTileView. This component allows you to preview check image to front or back on click.
 * @param {STRING} icon - Sets a check image to the component.
 * @param {STRING} onClick - Sets an event handler when the tile is clicked.
 */
function CheckImageTileView(props) {
  const image = props.image ?? "";
  const onClick = props.onClick ?? null;

  return (
    <ImageAsset id={image} onClick={onClick} className="clickable" />
  )
}
